import { useRef, useState } from "react";
import { Camera, Trash2 } from "lucide-react";
import { toast } from "sonner";
import { api } from "../lib/api";
import { Avatar, setAvatarCache } from "./Avatar";
import { Button } from "./ui/button";

const resize = (file) => new Promise((ok, ko) => {
  const img = new Image();
  img.onload = () => {
    const s = Math.min(img.width, img.height);
    const c = document.createElement("canvas");
    c.width = c.height = 320;
    c.getContext("2d").drawImage(img, (img.width - s) / 2, (img.height - s) / 2, s, s, 0, 0, 320, 320);
    URL.revokeObjectURL(img.src);
    ok(c.toDataURL("image/jpeg", 0.85));
  };
  img.onerror = () => ko(new Error("Formato immagine non supportato"));
  img.src = URL.createObjectURL(file);
});

export function AvatarEditor({ uid, self = false }) {
  const ref = useRef(null);
  const [busy, setBusy] = useState(false);
  const q = self ? "" : `?uid=${uid}`;
  const pick = async (e) => {
    const f = e.target.files?.[0];
    e.target.value = "";
    if (!f) return;
    setBusy(true);
    try {
      const image = await resize(f);
      await api("/web/avatar", { method: "PUT", body: { image, uid: self ? null : uid } });
      setAvatarCache(uid, image);
      toast.success("Foto profilo aggiornata");
    } catch (err) { toast.error(err.message); }
    setBusy(false);
  };
  const remove = async () => {
    try { await api(`/web/avatar${q}`, { method: "DELETE" }); setAvatarCache(uid, ""); toast.success("Foto rimossa"); } catch (err) { toast.error(err.message); }
  };
  return (
    <div className="flex items-center gap-5" data-testid="avatar-editor">
      <Avatar uid={uid} size="w-24 h-24" className="ring-4 ring-white shadow-md" testid="avatar-editor-image" />
      <div className="flex flex-col gap-2">
        <input ref={ref} type="file" accept="image/*" className="hidden" onChange={pick} data-testid="avatar-file-input" />
        <Button variant="outline" className="rounded-full" disabled={busy} onClick={() => ref.current?.click()} data-testid="avatar-upload-button"><Camera className="w-4 h-4 mr-1" />{busy ? "Caricamento…" : "Carica foto"}</Button>
        <Button variant="ghost" className="rounded-full text-[var(--red)]" onClick={remove} data-testid="avatar-remove-button"><Trash2 className="w-4 h-4 mr-1" />Rimuovi foto</Button>
      </div>
    </div>
  );
}
